import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";

/*
 * alertTypeToIcon
 * This object is used to map the alert type to the corresponding icon.
 */
export const alertTypeToIcon = {
  error: ExclamationCircleIcon,
  warning: ExclamationTriangleIcon,
  success: CheckCircleIcon,
  info: ExclamationCircleIcon,
  default: ExclamationCircleIcon,
};
